import Cookies from 'js-cookie'

const TokenKey = 'Token'
const CoreTokenKey = 'HuiCoreToken'
const UserName = 'UserName'
const OrgName = 'OrgName'
const OrgNo = 'OrgNo'
export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  Cookies.remove(TokenKey)
  return Cookies.remove(TokenKey)
}
export function getCoreToken () {
  return Cookies.get(CoreTokenKey)
}

export function setCoreToken (token) {
  return Cookies.set(CoreTokenKey, token)
}

export function removeCoreToken () {
  Cookies.remove(CoreTokenKey)
  return Cookies.remove(CoreTokenKey)
}
export function getUserName () {
  return Cookies.get(UserName)
}

export function setUserName (val) {
  return Cookies.set(UserName, val)
}

export function removeUserName () {
  return Cookies.remove(UserName)
}
export function getOrgName () {
  return Cookies.get(OrgName)
}

export function setOrgName (val) {
  return Cookies.set(OrgName, val)
}

export function removeOrgName () {
  return Cookies.remove(OrgName)
}
export function getOrgNo () {
  return Cookies.get(OrgNo)
}

export function setOrgNo (val) {
  return Cookies.set(OrgNo, val)
}

export function removeOrgNo () {
  return Cookies.remove(OrgNo)
}
